import { useEffect, useState } from "react";
import { Card, Col, Row, Table } from "react-bootstrap";
import { DashBoardService } from "../../services/DashBoardService";
import * as BullCache from '../../util/BullCache';
import "../custom.css";
import { useNavigate } from "react-router-dom";
import {isMobile} from '../../util/GeneralUtil'
import moment from 'moment';
import { ownSubscribe, sendMessage, unSubscribe } from '../../stomp/StompSocket';
import NumberFormatter from "../components/NumberFormatter";

function Dashboard() {

    const [latestTrade,setLatestTrade] = useState([]);
    const [pendingTrade,setPendingTrade] = useState([]);
    const [rejectionLogs,setRejectionLogs] = useState([]);
    const [m2mAlerts , setM2MAlerts] = useState([]);
    const [autoSquareOffList , setAuotSquareOffList] = useState([]);
    const navigate = useNavigate();
    var user = BullCache.getFromCache("user");

    useEffect(() => {
    DashBoardService.getAll({'adminId':user.adminId}).then(res=>{
        if(res.code===1){
            if(res.data.trades.length > 0){
                setLatestTrade(res.data.trades);
            }

            if(res.data.pendingOrders.length > 0){
                setPendingTrade(res.data.pendingOrders);
            }
            if(res.data.rejectionLogs.length>0){
                setRejectionLogs(res.data.rejectionLogs);
            }

            setAuotSquareOffList(res.data.autoSquareOffList);
            setM2MAlerts(res.data.m2mAlertList);
        }
    });


     const subscribeSocket = () => {
            ownSubscribe('/topic/dash/' + user.adminId, function (msg) {
                
                var newTrade = JSON.parse(msg.body);
                const trade = { ...newTrade, highlight: true };
                if(trade){
                  
                    if(trade.tradeType === 'EXECUTED'){
                        setLatestTrade(prevList => [trade, ...prevList].slice(0, 10));
                        if(!trade.orderType.includes('-MP')){
                             setPendingTrade(prevList => prevList.filter(item => !(item.userName === trade.userName && item.rate === trade.rate &&
                                item.orderType === trade.orderType && trade.orderTime === item.orderTime
                             )));
                        }
                         setTimeout(() => {
                            setLatestTrade(prev =>
                            prev.map(t =>
                                t === trade ? { ...t, highlight: false } : t
                            )
                            );
                        }, 2000);
                    }
                    else if(trade.tradeType === 'PENDING'){
                        setPendingTrade(prevList => [trade, ...prevList].slice(0, 10));
                        setTimeout(() => {
                            setPendingTrade(prev =>
                            prev.map(t =>
                                t === trade ? { ...t, highlight: false } : t
                            )
                            );
                        }, 2000);
                    }
                    else if(trade.tradeType === 'ERROR'){
                        setRejectionLogs(prevList => [trade, ...prevList].slice(0, 10));
                        setTimeout(() => {
                            setRejectionLogs(prev =>
                            prev.map(t =>
                                t === trade ? { ...t, highlight: false } : t
                            )
                            );
                        }, 2000);
                    }
                }

            }, 'dash-subscribe-id1')
            };

    const timeoutId = setTimeout(() => {
         componentWillUnmount1();
            subscribeSocket();
   
    }, 2000);

    // const intervalId =  setInterval(() => {
    //        sendMessage('/app/topic/ping/'+user.adminId, {});
    // }, 15000);

    return () => {
        clearTimeout(timeoutId); 
      //  clearInterval(intervalId); 
        componentWillUnmount1();
        };

    },[]);

  const componentWillUnmount1 = () => {
    unSubscribe('dash-subscribe-id1');
  }

function viewMore(page) {
    if(page){
        if(page === 'executed') {
            if(isMobile){
                navigate("/trademobile", { state: { page: "executed" } });
            } else {
                navigate("/trade", { state: { page: "executed" } });
            }
        } else if(page === 'pending') {
            if(isMobile){
                navigate("/trademobile", { state: { page: "pending" } });
            } else {
                navigate("/trade");
            }
        } else if(page === 'rejectionlog') {
            navigate("/rejectionlog");
        }
    }
}

    return (<Card className="mb-4">
        <Card.Body className="ps-1 pe-1">
            <Row>
                <Col xl={6} md={6} xs={12}>
                <Card>
                    <Card.Body  className="p-1" style={{height: "320px"}}>
                    <Card.Title className="text-center mt-0 mb-0 card-header-back">
                    <Row>
                        <Col xl={10} md={9} xs={8} className="text-center"><h6 className="table-header-color">LATEST TRADES</h6></Col>
                        <Col xl={2} md={3} xs={4} className="fss-05 viewmore-color"><label onClick={() => viewMore("executed")} style={{ cursor: "pointer" }}>View More &gt;</label></Col>
                    </Row>
                    </Card.Title>
                    <Table hover responsive>
                        <thead className="bg-header">
                            <tr >
                                {/* <th>#</th> */}
                                <th>O-Time/E-Time</th>
                                <th>Client</th>
                                <th>Script</th>
                                <th>Type</th>
                                <th>Lot</th>
                                <th>Qty</th>
                                <th>rate</th>
                            </tr>
                        </thead>
                        <tbody>
                        {latestTrade.length > 0 ? (                      
                            latestTrade.map((lt,index)=>{                      
                                const rowClass = lt.highlight ? 'blink-row text-nowrap' :  lt.orderType.includes("Buy") || lt.tradeType?.includes("B")  ? 'buy-background text-nowrap' : 'sell-background text-nowrap';
                                const fontColorClass = lt.orderType.includes("Buy") ? 'buy-color' : 'sell-color';                            
                                return(
                                 <tr className='fss-06'>
                                 {/* <td className={rowClass} >{index+1}</td> */}
                                 <td className={rowClass}> {moment(lt.orderTime, 'DD-MM-YYYY hh:mm:ss a').format('hh:mm:ss A')} {lt.inLimit != null &&  lt.inLimit ? '/'+ moment(lt.executedDate, 'DD-MM-YYYY hh:mm:ss a').format('hh:mm:ss A') : ''} </td>
                                 <td className={rowClass}>{lt.userName}</td>
                                 <td className={rowClass}>{lt.script}</td>
                                 <td className={`${rowClass} ${fontColorClass} text-nowrap`}>{lt.orderType.toUpperCase()}</td>
                                 <td className={rowClass}>{lt.lot}</td>
                                 <td className={rowClass}>{lt.quantity}</td>
                                 <td className={rowClass}>{lt.rate}</td>
                             </tr>);
                            })
                            ) : (
                            <tr>
                              <td colSpan="8" className="text-center" style={{height: "237px"}}>
                                <label className="fss-07"> No data available </label>
                              </td>
                            </tr>
                        )}
                        </tbody>
                    </Table>
                    </Card.Body>
                    </Card>
                </Col>

                <Col xl={6} md={6}>
                <Card  className={isMobile? "mt-1" : ''} >
                <Card.Body className="p-1" style={{height: "320px"}}>
                <Card.Title className="text-center mt-0 mb-0 card-header-back">
                    <Row>
                        <Col xl={10} md={9} xs={8} className="text-center"><h6 className="table-header-color">PENDING TRADES</h6></Col>
                        <Col xl={2} md={3} xs={4} className="fss-05 viewmore-color"><label onClick={() => viewMore("pending")} style={{ cursor: "pointer" }}> View More &gt;</label></Col>
                    </Row>
                    </Card.Title>
                    <Table  hover responsive>
                    <thead className="bg-header">
                            <tr >
                                {/* <th>#</th> */}
                                <th>Time</th>
                                <th>Client</th>
                                <th>Script</th>
                                <th>Type</th>
                                <th>Lot</th>
                                <th>Qty</th>
                                <th>rate</th>
                            </tr>
                        </thead>
                        
                        <tbody>
                        {pendingTrade.length > 0 ? (
                           pendingTrade.map((pt,index)=>{
                                const rowClass = pt.highlight ? 'blink-row text-nowrap' : pt.orderType.includes("Buy") ? 'buy-background text-nowrap' : 'sell-background text-nowrap';
                                const fontColorClass = pt.orderType.includes("Buy") ? 'buy-color' : 'sell-color';
                                return(
                                 <tr className="fss-06 ">
                                 {/* <td className={rowClass}>{index+1}</td> */}
                                 <td className={rowClass}>{moment(pt.orderTime, 'DD-MM-YYYY hh:mm:ss a').format('hh:mm:ss A')}</td>
                                 <td className={rowClass}>{pt.userName}</td>
                                 <td className={rowClass}>{pt.script}</td>
                                 <td className={`${rowClass} ${fontColorClass}`}>{pt.orderType.toUpperCase()}</td>
                                 <td className={rowClass}>{pt.lot}</td>
                                 <td className={rowClass}>{pt.quantity}</td>
                                 <td className={rowClass}>{pt.rate}</td>
                             </tr>);
                            })
                            ) : (
                            <tr>
                              <td colSpan="8" className="text-center" style={{height: "237px"}}>
                              <label className="fss-07"> No data available </label>
                              </td>
                            </tr>
                        )}
                        </tbody>
                    </Table>
                    </Card.Body>
                    </Card>
                </Col>                
            </Row>

            {user.adminType !== 'SUBBROKER' ?
            <>
            <Row className="mt-2">
                <Col>
                <Card>
                <Card.Body className="p-1">
                <Card.Title className="text-center mt-0 mb-0 card-header-back">
                    <Row>
                        <Col xl={11} md={10} xs={8} className="text-center"><h6 className="table-header-color ms-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;REJECTION LOGS</h6></Col>
                        <Col xl={1} md={2} xs={4} className="fss-05 viewmore-color"><label onClick={() => viewMore("rejectionlog")} style={{ cursor: "pointer" }}> View More &gt;</label></Col>
                    </Row>
                    </Card.Title>
                    <Table  hover responsive className="table-striped text-center">
                        <thead className="bg-header">
                            <tr>
                            {/* <th>#</th> */}
                            <th>Date</th>
                                <th>Client</th>
                                <th>Script</th>
                                <th>Type</th>   
                                <th>Lot</th>
                                <th>Qty</th>
                                <th>rate</th>
                                <th>Reason</th>
                            </tr>
                        </thead>
                        <tbody>
                        {rejectionLogs.length > 0 ? (
                            rejectionLogs.map((rg,index)=>{
                             const rowClass = rg.highlight ? 'blink-row text-nowrap' : rg.orderType.includes("Buy") ? 'buy-background text-nowrap' : 'sell-background text-nowrap';
                             const fontColorClass = rg.orderType.includes("Buy") ? 'buy-color' : 'sell-color';
                                return(
                                 <tr className="fss-06 ">
                                 {/* <td className={rowClass} >{index+1}</td> */}
                                 <td className={rowClass}>{rg.orderTime}</td>
                                 <td className={rowClass}>{rg.client != undefined ? rg.client : rg.userName}</td>
                                 <td className={rowClass}>{rg.script}</td>
                                 <td className={`${rowClass} ${fontColorClass}`}>{rg.orderType.toUpperCase()}</td>
                                 <td className={rowClass}>{rg.lot}</td>
                                 <td className={rowClass}>{rg.quantity}</td>
                                 <td className={rowClass}>{rg.rate}</td>
                                 <td className={rowClass}>{rg.remark}</td>
                             </tr>);
                            })
                            ) : (
                            <tr>
                              <td colSpan="9" className="text-center">
                              <label className="fss-07"> No data available </label>
                              </td>
                            </tr>
                        )}
                           
                        </tbody>
                    </Table>
                    </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row className="mt-2">
                <Col xl={6} md={6}>
                <Card >
                    <Card.Body className="p-1">
                    <Card.Title className="text-center mt-0 mb-0 card-header-back">
                    <Row>
                        <Col xl={12} className="text-center"><h6 className="table-header-color">M2M ALERTS</h6></Col>
                    </Row>
                    </Card.Title>
                    <Table hover responsive className="table">
                        <thead className="bg-header">
                            <tr>
                                {/* <th>#</th> */}
                                <th>CODE</th>
                                <th>LEDGER BALANCE</th>
                                <th>LOSS ALERT(%)</th>
                                <th>M2M</th>
                                <th>LEDGER+M2M</th>
                            </tr>
                        </thead>
                        <tbody className="">
                                {m2mAlerts.length > 0 ? (
                                     m2mAlerts.map((ma,index)=>{
                                        return(
                                            <>
                                            <tr>
                                            <td className="text-black fss-06 p-2 white-row">{ma.fullName}</td>
                                            <td className="text-black fss-06 p-2 ps-2 white-row"><NumberFormatter number={ma.balance}></NumberFormatter></td>
                                            <td className="text-black fss-06 p-2 ps-2 white-row">{ma.lossAlert}</td>
                                            <td className="text-black fss-06 p-2 ps-2 white-row"><NumberFormatter number={ma.m2m}></NumberFormatter></td>
                                            <td className="text-black fss-06 p-2 ps-2 white-row"><NumberFormatter number={ma.leaserM2m}></NumberFormatter></td>
                                            </tr>
                                            </>
                                        )
                                    })
                                ): (
                                    <tr>
                                      <td colSpan="9" className="text-center fss-07">
                                        No data available
                                      </td>
                                    </tr>
                                )}
                        </tbody>
                    </Table>
                    </Card.Body>
                    </Card>
                </Col>

                <Col xl={6} md={6}>
                <Card className={isMobile ? "mt-1 mb-5" : ""}>
                <Card.Body className="p-1">
                <Card.Title className="text-center mt-0 mb-0 card-header-back">
                    <Row>
                        <Col xl={12} className="text-center"><h6 className="table-header-color">AUTO SQUARE OFF LIST</h6></Col>
                    </Row>
                    </Card.Title>
                    <Table  hover responsive className="table ">
                        <thead className="bg-header">
                            <tr>
                                {/* <th>#</th> */}
                                <th>USER</th>
                                <th>LEDGER BALANCE</th>
                                
                            </tr>
                        </thead>
                        <tbody className=""> 
                        {autoSquareOffList.length > 0 ? (
                                     autoSquareOffList.map((as,index)=>{
                                        return(
                                            <>
                                            <tr>
                                            <td className="text-black fss-06 p-2 white-row">{as.fullName}</td>
                                            <td className="text-black fss-06 p-2 ps-2 white-row"><NumberFormatter number={as.balance}></NumberFormatter></td>
                                            </tr>
                                            </>
                                        )
                                    })
                                ): (
                                    <tr>
                                      <td colSpan="9" className="text-center fss-07" >
                                        No data available
                                      </td>
                                    </tr>
                                )}
                        </tbody>
                    </Table>
                    </Card.Body>
                    </Card>
                </Col>
            </Row>

            </> : ""}

        </Card.Body>
    </Card>)
}

export default Dashboard;